// extracted by mini-css-extract-plugin
export default {"anvilWidgetWrapper":"styles_anvilWidgetWrapper__O29hs"};